const routes = [
  {
    path: '/peopleInfo',
    name: 'peopleInfo',
    component: () => import('./view/peopleInfo.vue'),
    meta: {
      requireAuth: false,
      routerAlive: true
    },
  },
]

export default routes
